import { NgModule } from "@angular/core";
import { CatalogEditModule } from "../catalog-edit.module";
import { ItemCreateDialogService } from "./item-create-dialog.service";

/**
 * Modulo wrapper che espone ItemCreateDialogService.
 * Non dichiara component propri: riusa direttamente CatalogEditComponent
 * che viene aperto come dialog tramite ItemCreateDialogService.
 */
@NgModule({
  imports: [
    CatalogEditModule   // necessario per entryComponents (Ivy lo gestisce automaticamente)
  ],
  providers: [
    ItemCreateDialogService
  ]
})
export class ItemCreateDialogModule {}
